import { useHistory } from "react-router-dom";

const NonAccess = () => {
  const history = useHistory();
  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        fontSize: "30px",
        fontWeight: "700",
        marginTop: "20%",
      }}
    >
      You need to login to access this page
      <div
        onClick={() => {
          history.push("/");
        }}
        style={{
          textDecoration: "underline",
          color: "#69C7DD",
          cursor: "pointer",
        }}
      >
        Go Home
      </div>
    </div>
  );
};

export default NonAccess;
